import * as t from '../constants/ActionTypes';
import { handleActions } from 'redux-actions';

const initialState = {
  isNotificationShown: false
};

export default handleActions({
  [`${t.SHOW_PAYMENT_NOTIFCATION}`]: (state, { payload }) => ({
    ...state,
    isNotificationShown: true
  }),
  [`${t.HIDE_PAYMENT_NOTIFCATION}`]: (state, { payload }) => ({
    ...state,
    isNotificationShown: false
  })
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/payments.js